export default __webpack_public_path__ + "static/media/70468.8c6ad06b.jpg";